import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";

export class ValdnWidgetsComparisonModel extends WidgetsAbstract {
    readonly icon: string = 'fact_check';
    readonly name: string = 'Comparison';
    readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.VALDN_COMP;
    readonly template = 'requiredIfFields';
    readonly badge: string = 'VC';
    readonly placeholderClassName: string = 'valdn-placeholder';
    readonly type: string = 'valdn';

    cloneFrom(origin: WidgetsAbstract) : WidgetsAbstract {
        return this;
    }    
}
